import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=0acaf435&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acaf435')) {
      api.createRecord('0acaf435', component.options)
    } else {
      api.reload('0acaf435', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=0acaf435&", function () {
      api.rerender('0acaf435', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/ResetPassword.vue"
export default component.exports